import ServiceExec from '@/common/utils/ServiceExec';
import { notification } from '@/common/service/apiList';
import store from '@/store';

export default {
  getNotificationList: async function({ state, commit, getters }) {
    const condition = getters['getCondition'];
    const { userNo } = store.getters['user/getUserData'];
    // 260506 fix: 첫 page(1)는 무조건 fetch. 이전엔 endPage 0/stale로 진입조차 차단.
    //          infinite-scroll 다음 페이지(page>1)만 endPage 비교.
    if (condition.page > 1 && condition.page > state.pageInfo.endPage) return false;
    condition.userNo = userNo;
    const { data, status } = await ServiceExec.get(notification.getList, condition);
    if (ServiceExec.status.OK !== status) return false;
    const { list, pageInfo } = data;
    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setPageInfo', pageInfo);
    commit('setNotificationList', list ?? []);
  },
  async getDetail({ commit, getters, state }, notificationNo) {
    const { data, status } = await ServiceExec.get(notification.getDetail + notificationNo);
    if (ServiceExec.status.OK !== status) return;
    commit('setDetail', data ?? '');
  },

  async updateRead({ commit, getters, state, dispatch }, notificationNo) {
    const { userNo } = store.getters['user/getUserData'];
    const { status, data } = await ServiceExec.put(notification.updateRead, {
      userNo,
      id: notificationNo
    });
    if (ServiceExec.status.OK !== status) return;
    // 260506: 읽음 처리되면 헤더 뱃지 즉시 갱신.
    dispatch('fetchUnreadCount');
    // 260521 fix: 클라 list state도 옵티미스틱하게 read로 마킹. 상세 보고 뒤로
    //   돌아왔을 때 keep-alive로 stale list가 그대로 노출되며 opacity30(읽음 UI)이
    //   안 붙던 버그. BE는 INSERT 정상이지만 클라 state 미갱신.
    //   NotificationCard는 `item?.id` truthy면 opacity30 → sentinel -1 채움.
    commit('markListItemRead', notificationNo);
    return data;
  },
  // 260506: per-user 알림 삭제 후 list 재로드
  // ServiceExec.delete(path, payload)에서 payload는 query params로 직접 전달.
  async deleteNotification({ commit, dispatch }, notificationNo) {
    const { userNo } = store.getters['user/getUserData'];
    const { status } = await ServiceExec.delete(notification.delete(notificationNo), { userNo });
    if (ServiceExec.status.OK !== status) return false;
    // 삭제 후 list 재초기화 → 새로 fetch
    commit('initPage');
    await dispatch('getNotificationList');
    // 미열람 알림 삭제했을 가능성 → 뱃지 재계산.
    dispatch('fetchUnreadCount');
    return true;
  },
  // 260618: 전체 읽음 — per-user + broadcast 모두 읽음 처리 후 list 재로드 + 뱃지 갱신.
  async markAllRead({ commit, dispatch }) {
    const { userNo } = store.getters['user/getUserData'];
    if (!userNo) return false;
    const { status } = await ServiceExec.put(notification.readAll, {});
    if (ServiceExec.status.OK !== status) return false;
    commit('initPage');
    await dispatch('getNotificationList');
    dispatch('fetchUnreadCount');
    return true;
  },
  // 260618: 전체 삭제 — per-user 삭제 + broadcast hide 후 list 재로드 + 뱃지 갱신.
  async deleteAll({ commit, dispatch }) {
    const { userNo } = store.getters['user/getUserData'];
    if (!userNo) return false;
    const { status } = await ServiceExec.delete(notification.deleteAll, {});
    if (ServiceExec.status.OK !== status) return false;
    commit('initPage');
    await dispatch('getNotificationList');
    dispatch('fetchUnreadCount');
    return true;
  },
  // 260506: 메인 헤더 종 아이콘 뱃지용 미열람 개수 조회.
  // 비로그인이면 0 유지, 호출 자체 skip.
  async fetchUnreadCount({ commit }) {
    const { userNo } = store.getters['user/getUserData'];
    if (!userNo) {
      commit('setUnreadCount', 0);
      return 0;
    }
    const { data, status } = await ServiceExec.get(notification.unreadCount, { userNo });
    if (ServiceExec.status.OK !== status) return 0;
    const count = typeof data === 'number' ? data : Number(data ?? 0);
    commit('setUnreadCount', count);
    return count;
  }
};
